module.exports = __webpack_public_path__ + "img/microsoft.8e690f1b.svg";